/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import styled from 'styled-components';
import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/solid';
import { ScrollMenu } from 'react-horizontal-scrolling-menu';

export const CoverImageStyle: any = {
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundAttachment: 'fixed',
  borderRadius: '30px',
};

export const imageStyle: any = {
  width: '40vw',
  height: '300px',
  objectFit: 'cover',
  borderRadius: '20px',
  cursor: 'pointer',
};

export const CarouselItemContainer = styled.div`
  margin-right: 10px;
  height: 40px;
  margin-top: 15px;
  height: auto;
  border-bottom: ${(props: any) =>
    props?.active ? '2px solid #606060' : 'none'};
  @media (max-width: 414px) {
    margin-top: 0;
  }
  @media (max-width: 1000px) {
    margin-top: 0px;
  }
`;

export const DocumentContainer: any = {
  marginTop: '0px',
  alignSelf: 'center',
  alignItems: 'center',
  justifyContent: 'center',
};

export const NavLink: any = styled.div`
  padding: 0 5px;
  white-space: nowrap;
  width: max-content;
  @media (max-width: 414px) {
    margin-left: 0;
    padding: 0;
    padding: 3px;
  }
  color: #606060;
  &:hover {
    color: black;
  }
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Anchor = styled.a`
  padding: 0.5rem 0.5rem;
  color: ${(props: any) => (props?.active ? '#104382' : '#606060')};
  font-size: ${(props: any) =>
    props?.fontScale !== undefined
      ? `${16 + props?.fontScale * 1.5}px`
      : '0.9rem'};
  font-weight: 500;
  letter-spacing: 0.5px;
  transform: ${(props: any) => (props?.active ? 'scale(1.1)' : 'scale(1)')};
  transition: 0.3s ease-in-out;
  text-transform: uppercase;
  letter-spacing: ${(props: any) => (props?.active ? '1px' : '0.5px')};
  &:hover {
    color: ${(props: any) => (props?.active ? '#104382' : 'black')};
  }
`;

export const ScrollContainer = styled.div`
  .react-horizontal-scrolling-menu--scroll-container {
    overflow-x: hidden;
    border-bottom: 1px solid #e5e4e2;
    position: relative;
  }
`;

export const ArrowRight = styled(ChevronRightIcon)`
  cursor: pointer;
  align-self: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  right: 1%;
  user-select: none;
  margin-bottom: 10px;
  @media (max-width: 414px) {
    margin-bottom: 0px;
  }
`;
export const ArrowLeft = styled(ChevronLeftIcon)`
  cursor: pointer;
  align-self: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  right: 1%;
  user-select: none;
  margin-bottom: 10px;
  @media (max-width: 414px) {
    margin-bottom: 0px;
  }
`;
